module.exports = new __parcel__URL__("mining_cancel_dialog_confirm_button.8f2f0f65.png").toString();